"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SalesEnablementEventTypes;
(function (SalesEnablementEventTypes) {
    SalesEnablementEventTypes["IS_CHECKOUT_PAGE"] = "DXP_IS_CHECKOUT_PAGE";
    SalesEnablementEventTypes["REQUEST_SESSION_ID"] = "DXP_REQUEST_SE_SESSION_ID";
    SalesEnablementEventTypes["SESSION_ID"] = "DXP_SE_SESSION_ID";
    SalesEnablementEventTypes["RELOAD_DEAL"] = "DXP_RELOAD_DEAL";
    SalesEnablementEventTypes["IS_DEAL_EXPORTED"] = "DXP_IS_DEAL_EXPORTED";
})(SalesEnablementEventTypes = exports.SalesEnablementEventTypes || (exports.SalesEnablementEventTypes = {}));
